<template>
    <div class="Intelligentmatching">
        <div class="header">
            <el-row>
                <el-col :span="8">
                    <label class="headerlabel">规则名称</label>
                    <el-input v-model="param.keyWord" placeholder="请输入规则名称" class="autowidth" clearable></el-input>
                </el-col>
                <el-col :span="8">
                    <label class="headerlabel">匹配标签</label>
                    <el-select v-model="param.tag" placeholder="请选择" filterable  class="autowidth" clearable >
                        <el-option v-for="item in tagListData" :label="item.value" :value="item.key"></el-option>
                    </el-select>
                </el-col>
                <el-col :span="8">
                    <label class="headerlabel">内容类型</label>
                    <el-select v-model="param.type" placeholder="请选择" filterable  class="autowidth" clearable >
                        <el-option v-for="item in contentData" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                    <el-button type="primary" style="margin-left: 24px;" @click="init">筛选</el-button>
                    <el-button @click="reset">重置条件</el-button>
                </el-col>
            </el-row>
        </div>

        <main class="MainContent">
            <el-button type="primary" style="margin-bottom: 10px;" @click="dialogVisible=true">新建规则匹配</el-button>
            <el-table
            :data="listData"
            v-loading="loading"
            element-loading-text="拼命加载中"
            element-loading-spinner="el-icon-loading"
            style="width: 100%;margin-bottom: 20px;">
                <el-table-column prop="ruleName" label="规则名称"></el-table-column>
                <el-table-column prop="tagStr" label="匹配标签"></el-table-column>
                <el-table-column prop="contentType" label="内容类型"></el-table-column>
                <el-table-column label="是否启用">
                    <template slot-scope="scope">
                        <div>{{ scope.row.isActive?'是':'否' }}</div>
                    </template>
                </el-table-column>
                <el-table-column prop="lineNumber" label="排序"></el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <el-button type="text" style="margin-right: 10px;" @click="ClickDetial(scope.row)">编辑</el-button>
                        <el-popconfirm title="是否确定删除？" @confirm="confirm(scope.row)">
                            <el-button type="text" style="color: #F24B4E;" slot="reference">删除</el-button>
                        </el-popconfirm>
                    </template>
                </el-table-column>
            </el-table>

            <el-pagination
            :hide-on-single-page=true
            @current-change="handleinitialization"
            :current-page.sync="param.pageIndex"
            :page-size="param.pageSize"
            layout="total, prev, pager, next"
            :total="param.PageTotal">
        </el-pagination>
        </main>

        <el-dialog
            title="新建规则匹配"
            :visible.sync="dialogVisible"
            width="480px"
            center
            :before-close="handleClose">
           <div class="ruleContent">
            <div class="item">
                <label>规则名称</label>
                <el-input v-model="insetParam.ruleName" placeholder="请输入规则名称" class="autowidth" clearable></el-input>
            </div>
            <div class="item">
                <label>匹配标签</label>
                <el-select v-model="tagKeys" multiple  placeholder="请选择" filterable  class="autowidth" clearable >
                    <el-option v-for="item in tagListData" :label="item.value" :value="item.key"></el-option>
                </el-select>
            </div>
            <div class="item">
                <label>内容类型</label>
                <el-select v-model="contentType" multiple  placeholder="请选择" filterable  class="autowidth" clearable >
                    <el-option v-for="item in contentData" :label="item.label" :value="item.value"></el-option>
                </el-select>
            </div>
            <div class="item">
                <label>是否启用</label>
                <el-switch v-model="insetParam.isActive" :active-value="1" :inactive-value="0"></el-switch>
            </div>
            <div class="item">
                <label>排序</label>
                <el-input type="number" v-model="insetParam.lineNumber" placeholder="请输入" class="autowidth" clearable></el-input>
            </div>
           </div>
            <div style="text-align: center;margin: 20px 0 10px;">
                <el-button @click="handleClose">取消</el-button>
                <el-button type="primary"  @click="ClickAgree">同意</el-button>
            </div>
        </el-dialog>

    </div>
</template>
<script>
export default{
    data() {
        return {
            loading:false,
            param:{
                pageIndex:1,
                pageSize:10,
                PageTotal:0,
                keyWord:'',
                tag:'',
                type:''
            },
            insetParam:{
                ruleKey:'',
                ruleName:'',
                contentType:'',
                tagKeys:'',
                isActive:true,
                lineNumber:0
            },
            tagKeys:[],
            contentType:[],
            listData:[],
            dialogVisible:false,
            tagListData:[],
            contentData:[
                {label:'文章',value:'1'},
                {label:'音乐',value:'2'},
                {label:'视频',value:'3'},
                {label:'测评',value:'4'},
                {label:'冥想',value:'5'},
            ]
        }
    },
    mounted() {
        this.init();
        this.tagList();
    },
    methods:{
        init(){
            this.loading=true;
            this.$Http_Post('/smartRule/getlist',this.param).then(res=>{
                this.loading=false;
                if(res.Code==0){
                    this.param.PageTotal=res.Counts;
                    this.listData=res.Data;
                }else{
                    this.$message.error(res.Message);
                }
            })
        },
        // 匹配标签
        tagList(){
            this.$Http_Post('/management/tagList',).then(res=>{
                if(res.Code==0 || res.Code==200){
                    this.tagListData=res.Data;
                }else{
                    this.$message.error(res.Message);
                }
            });
        },
        reset(){
            this.param=this.$options.data().param;
            this.init();
        },
        handleinitialization(val){
            this.param.pageIndex=val;
            this.init();
        },
        // 删除
        confirm(val){
            let Data={
                ruleKey:val.ruleKey,
                ruleName:val.ruleName,
                contentType:val.contentType,
                tagKeys:val.tagKeys,
                isActive:val.isActive,
                lineNumber:val.lineNumber
            }
            this.$Http_Post('/smartRule/delete',Data).then(res=>{
                if(res.Code==0 || res.Code==200){
                    this.$message.success(res.Message);
                    this.init();
                }else{
                    this.$message.error(res.Message);
                }
            })
        },
        // 添加/编辑
        ClickDetial(val){
            this.insetParam.ruleKey=val.ruleKey;
            this.insetParam.ruleName=val.ruleName;
            this.insetParam.contentType=val.contentType;
            this.insetParam.tagKeys=val.tagKeys;
            this.insetParam.isActive=val.isActive?1:0;
            this.insetParam.lineNumber=val.lineNumber;
            this.tagKeys=val.tagKeys.split(",");
            this.contentType=val.typeKeys.split(",");
            this.dialogVisible=true;
        },
        handleClose(){
            this.dialogVisible=false;
        },
        ClickAgree(){
            this.insetParam.tagKeys=this.tagKeys.toString();
            this.insetParam.contentType=this.contentType.toString();
            this.$Http_Post('/smartRule/upsert',this.insetParam).then(res=>{
                if(res.Code==0 || res.Code==200){
                    this.init();
                    this.dialogVisible=false;
                    this.$message.success(res.Message);
                }else{
                    this.$message.error(res.Message);
                }
            })
        },
    },
}
</script>
<style scoped>
.Intelligentmatching .header{background: #fff;padding:20px;}
.Intelligentmatching .header .headerlabel{width:90px;display: inline-block;}
.Intelligentmatching .autowidth{width: 240px;}
.Intelligentmatching .MainContent{background: #fff;padding:20px 16px;margin:16px 0;}
.Intelligentmatching .ruleContent {margin: 0 20px;}
.Intelligentmatching .ruleContent .item{padding-top: 15px;}
.Intelligentmatching .ruleContent .item label{margin-right: 15px;width:60px;display: inline-block;}
</style>